<div class="lesson-progress fixed-bottom hidden-sm-down">
  <div class="progress">
    @for (section of breadCrumbSections; track section) {
      <div role="progressbar" style="width: 20%;" aria-valuenow="20" aria-valuemin="0"
        class="progress-bar"
        [ngClass]="{'progress-bar': true, 'incomplete': section.id !== currentSection}"
        aria-valuemax="100">{{section.label  | number:'1.2-2' }}
      </div>
    }
  </div>
</div>
